/**
 * Created by Bimal James on 2015-02-17.
 */
define('all/player/uk-deposittandc',['jquery', 'all/dialog', 'all/paymentServices-toggles'], function($, dialog, paymentServicesToggles) {
    'use strict';

    function verifyUKDepositTandCStatus(callback) {
        $.ajaxSetup({
            async: false
        });

		var url = '/UkComplianceService/ukDepositTandCAgreementCheckService?isMobileDevice=false';
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			url = '/pp?flow=UKDepositTandCAgreementCheck';
		}

		$.getJSON(url, {
        }, function(data) {
            if(typeof callback === 'function'){
                callback(data);
            }
            $.ajaxSetup({
                async: true
            });
        });
    }

    function updateUKTandCForDeposit(callback) {
        $.ajaxSetup({
            async: false
        });

		var url = '/UkComplianceService/ukDepositTandCAgreementRemoveDepositPopup?isMobileDevice=false';
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			url = '/pp?flow=UKDepositTandCAgreementUpdate';
		}

        $.getJSON(url, {
        }, function(data) {
            if(typeof callback === 'function'){
                callback(data);
            }
            $.ajaxSetup({
                async: true
            });
        });
    }


    window.ukdeposittandc = {
        verifyUKDepositTandCStatus: verifyUKDepositTandCStatus,
        updateUKTandCForDeposit: updateUKTandCForDeposit
    };

    return window.ukdeposittandc;
});

